import {Button, Typography} from 'antd';
import React, {} from 'react';

import House_CheckImg from '../../../assets/House_Check.png';

const {Title, Text} = Typography;

const FinalScreen: React.FC = () => {

  const onLogin = () => {
    window.location.href = '/';
  };

  return (
    <div className="otp-container">
         <img src={House_CheckImg} alt="" style={{width: 110}} />
        <Title level={2} style={{marginTop: -10}}>You have Verified your Email Successfully</Title>
        <Text style={{fontWeight: '600', fontSize: '16px'}}>
            Now, go ahead and login with your new credentials
        </Text>
        <Button
            type="primary"
            block
            onClick={onLogin}
            style={{
            marginTop: 20,
            height: 44,
            backgroundColor: 'rgb(21, 154, 132)',
            fontWeight: 600
            }}
        >
        Login
        </Button>
      </div>
  );
};

export default FinalScreen;
